import { Alert, Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { useFormContext } from 'core/states';
import { Color, Level, Size, Variant } from 'theme/enums';

interface IProps {
  externalReplacementCost: number;
  isCostSourceExternal: boolean;
}

export const ShipAndDebitVendorWarning = ({
  externalReplacementCost,
  isCostSourceExternal,
}: IProps) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const isReplacementCostCustomValue = watch('isReplacementCostCustom');
  const purchaseCostValue = Number(watch('purchaseCost'));
  const replacementCostValue = Number(watch('replacementCost'));

  const shouldShow =
    !!externalReplacementCost &&
    !!isReplacementCostCustomValue &&
    (isCostSourceExternal || purchaseCostValue >= replacementCostValue);

  if (!shouldShow) {
    return null;
  }

  return (
    <Alert
      startDecorator={<Warning style={{ width: 24, height: 24 }} />}
      variant={Variant.SOFT}
      color={Color.WARNING}
      size={Size.LG}
      sx={{
        alignItems: 'flex-start',
        width: '100%',

        '& .MuiAlert-startDecorator': {
          marginTop: '2px',
        },
      }}
    >
      <Typography level={Level.BODY_SM}>{t('warningReplacementCostNonStock')}</Typography>
    </Alert>
  );
};
